import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carlos Méndez',
    age: 28,
    profession: 'Técnico Dental',
    city: 'Buenos Aires',
    text: 'Trabajo hace 3 años en un laboratorio y este material me abrió los ojos. Ahora entiendo por qué me rechazaban algunos trabajos. Las explicaciones son clarísimas y los tips son oro puro.'
  }, {
    name: 'Ana Rodríguez',
    age: 24,
    profession: 'Estudiante de Prótesis Dental',
    city: 'Mendoza',
    text: 'Recién arranco en esto y me salvó la vida. En el instituto te enseñan la teoría pero acá está todo lo práctico que necesitás para trabajar de verdad. Lo recomiendo 100%.'
  }, {
    name: 'Roberto Silva',
    age: 35,
    profession: 'Técnico Dental Senior',
    city: 'Córdoba',
    text: 'Llevo años en el rubro y aún así aprendí un montón, especialmente en la parte digital. Está todo super bien explicado y actualizado. Vale cada peso.'
  }, {
    name: 'Gabriela Torres',
    age: 30,
    profession: 'Técnica Dental',
    city: 'Rosario',
    text: 'Estaba pensando en montar mi propio laboratorio y no sabía por dónde empezar. El capítulo 7 me dio toda la info que necesitaba. Súper completo y práctico.'
  }, {
    name: 'Javier Gómez',
    age: 26,
    profession: 'Técnico Dental Junior',
    city: 'La Plata',
    text: 'Lo mejor es que no te venden humo. Todo es aplicable desde el día uno. Los bonos son increíbles, especialmente la calculadora de precios. Me ayudó a no regalar mi trabajo.'
  }];
  return <section className="w-full px-4 py-12 bg-gray-50" data-id="element-166">
      <div className="max-w-6xl mx-auto" data-id="element-167">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-168">
          Lo que dicen quienes ya lo tienen
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-169">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md" data-id="element-170">
              <div className="flex gap-1 mb-4" data-id="element-171">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-172" />)}
              </div>
              <p className="text-gray-700 mb-4 italic" data-id="element-173">"{testimonial.text}"</p>
              <div className="border-t pt-4" data-id="element-174">
                <p className="font-semibold text-gray-900" data-id="element-175">
                  {testimonial.name}, {testimonial.age}
                </p>
                <p className="text-sm text-gray-600" data-id="element-176">
                  {testimonial.profession}
                </p>
                <p className="text-sm text-gray-500" data-id="element-177">{testimonial.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}